import React  from 'react';

import Layout from '../components/layouts/standard-page.js';
import ContentLayout from '../components/layouts/content-just-header-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHead from '../components/card-header.js';
import LanguageSelector from '../components/inputs/language-selector.js';
import {Panel , ListGroupItem , Thumbnail , ListGroup  ,  NavItem , Row , Col , Alert , FormGroup , ControlLabel , FormControl , Button} from 'react-bootstrap';
import ContentService from '../services/content-service.js';
import ContentStore   from  '../store/content-store.js';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import InternationalizationStore from '../store/internationalization-store.js';
import { FormattedMessage } from 'react-intl';
import Navigation from '../components/layouts/content-header.js';
import VocabObject from '../components/content-vocab.js';


export default class ContentBuilderCheckout extends React.Component{

    constructor(props) {
        super(props);
        this.CatalogParams = {catalogUID:this.props.params.catalogUID  }
        this.state = {
            catalog:ContentStore.getCatalog(this.props.params.catalogUID),
            title:"",
            description:"",
            open:true,
            summary:ContentStore.getCatalogSummary(this.props.params.catalogUID).summary
        }

    }

    componentWillMount() {

        ContentService.fetchCatalogSummary(this.CatalogParams.catalogUID )
    }

    componentDidMount() {
        ContentStore.on('ON_VOCAB_FETCH'  , () => {

            this.setState({
                catalog:ContentStore.getCatalog(this.props.params.catalogUID)
            })

        });

        ContentStore.on('ON_SUMMARY_FETCH'  , () => {

            let summary = ContentStore.getCatalogSummary(this.props.params.catalogUID).summary;

            this.setState({
                title:ContentStore.getCatalogSummary(this.props.params.catalogUID).summary.title,
                description:ContentStore.getCatalogSummary(this.props.params.catalogUID).summary.description,
                summary:ContentStore.getCatalogSummary(this.props.params.catalogUID).summary
            });

            ContentService.fetchCatalog(this.CatalogParams.catalogUID , summary.learning_ietf , summary.support_ietf );

        });
    }

    componentWillReceiveProps(props){

        this.props = props;

        var newCatalogParams = {catalogUID:props.params.catalogUID  }

        if(JSON.stringify(this.CatalogParams) != JSON.stringify(newCatalogParams))
       {
            this.CatalogParams = newCatalogParams

            ContentService.fetchCatalogSummary(this.CatalogParams.catalogUID)

       }

    }

    publishContent(){

        if(this.state.summary.state == "PUBLISHED")
        {
            ContentService.unPublish(this.CatalogParams.catalogUID).then(function(){
                window.location.hash = "/builder/overview";

            });
        }
        else
        {
            ContentService.publish(this.CatalogParams.catalogUID).then(function(){
                window.location.hash = "/builder/overview";
            });
        }
    }

    assignContent(){

        if(this.state.summary.state == "PUBLISHED")
        {
            window.location.hash = "/builder/assign/"+this.CatalogParams.catalogUID;
        }
        else
        {

            ContentService.publish(this.CatalogParams.catalogUID).then(function(){
                window.location.hash = "/builder/assign/"+this.CatalogParams.catalogUID;
            }.bind(this));
        }

    }

    isOpen(isOpen){
        this.setState({open:isOpen})
    }


    render()
    {

        if(!this.state.catalog) return null;
        if(this.state.summary.id === null) return null;

        var VocabObjects = [];

        for(var idx = 0 ; idx < this.state.catalog.vocab.length; idx++)
        {
            let vocabObject = this.state.catalog.vocab[idx];
            VocabObjects.push(<Col md={4}><VocabObject catalogUID={this.props.params.catalogUID} vocab={vocabObject}/></Col>);
        }


        let warning = null;


        if(VocabObjects.length > 10)
        {
            warning = <Alert bsStyle="warning">
                <FormattedMessage id={"ui-2217"} defaultMessage={"Unpublish"} />
            </Alert>
        }

        if(VocabObjects.length < 8)
        {
            warning = <Alert bsStyle="warning">
                <FormattedMessage id={"ui-2218"} defaultMessage={"Unpublish"} />
            </Alert>
        }

        return  <Layout>
                    <Row>
                        <Col md={9}>
                            <Navigation onOpen={this.isOpen.bind(this)} catalogUID={this.props.params.catalogUID} />
                            <Panel className="p-0" collapsible expanded={this.state.open}>
                            <Card>
                                <CardHead>
                                    <h4>{this.state.summary.title}</h4>
                                    <small> {this.state.summary.description}</small>
                                </CardHead>
                                <CardBody>
                                    <Row>
                                        {VocabObjects}
                                    </Row>

                                </CardBody>
                            </Card>
                            </Panel>
                        </Col>
                        <Col md={3}>

                            <Card>
                                <CardHead>
                                    <h4>{this.state.summary.title}</h4>
                                    <small>{this.state.summary.description}</small>
                                </CardHead>
                                <CardBody>
                                    {warning}
                                    <ListGroup>
                                        <ListGroupItem><FormattedMessage id={"ui-2215"} defaultMessage={"Total Vocabulary:"} /> {this.state.catalog.vocab.length}</ListGroupItem>
                                        <ListGroupItem><FormattedMessage id={"ui-2211"} defaultMessage={"Learning Language:"} /> <FormattedMessage id={ 'ui-'+this.state.summary.learning_translation } defaultMessage={ '' }/></ListGroupItem>
                                        <ListGroupItem><FormattedMessage id={"ui-2212"} defaultMessage={"Support Language:"} />  <FormattedMessage id={ 'ui-'+this.state.summary.support_translation } defaultMessage={ '' }/></ListGroupItem>
                                    </ListGroup>
                                    <br />
                                    <Button disabled={VocabObjects.length < 8} onClick={this.publishContent.bind(this)} bsStyle="primary" block><b>{this.state.summary.state == "PUBLISHED" ? <FormattedMessage id={"ui-2213"} defaultMessage={"Unpublish"} />  : <FormattedMessage id={"ui-666"} defaultMessage={"Publish"} /> }</b></Button>
                                    <Button disabled={VocabObjects.length < 8} onClick={this.assignContent.bind(this) } bsStyle="primary" block> {this.state.summary.state != "PUBLISHED" ? <FormattedMessage id={"ui-2214"} defaultMessage={"Publish & Assign"} /> : <FormattedMessage id={"ui-974"} defaultMessage={"Assign"} />}</Button>
                                </CardBody>
                            </Card>

                        </Col>
                    </Row>
                </Layout>

    }

}


// WEBPACK FOOTER //
// ./src/screens/content-bulider-checkout.js